module.exports = __webpack_public_path__ + "img/ring_r_0_0_null@2x.558bda71.png";